import { ImportFileDialog } from "@/components/CSV/ImportFileDialog";
import { parseBooleanField } from "@/utils/tools";
import type { RowData } from "./Index";
import { columnsKey } from "./Index";
import { createEmptyRow } from "./helper";

interface CSVImportFileDialogProps {
	open: boolean;
	onClose: () => void;
	onImport: (rows: RowData[]) => void;
}

function parseSenderRow(raw: Record<string, any>): RowData {
	return {
		email: { value: String(raw.email), disabled: false, isValid: false },
		password: { value: String(raw.password), disabled: false, isValid: false },
		proxyIp: { value: String(raw.proxyIp), disabled: false, isValid: false },
		senderGroupName: {
			value: String(raw.senderGroupName),
			disabled: false,
			isValid: false,
		},
		senderPriority: {
			value: String(raw.senderPriority),
			disabled: false,
			isValid: false,
		},
		backupCode: {
			value: String(raw.backupCode),
			disabled: false,
			isValid: false,
		},
		gauth: { value: String(raw.gauth), disabled: false, isValid: false },
		imapServer: {
			value: String(raw.imapServer),
			disabled: false,
			isValid: false,
		},
		imapUsername: {
			value: String(raw.imapUsername),
			disabled: false,
			isValid: false,
		},
		imapPassword: {
			value: String(raw.imapPassword),
			disabled: false,
			isValid: false,
		},
		imapPort: {
			value: raw.imapPort ? Number(raw.imapPort) || null : null,
			disabled: false,
			isValid: false,
		},
		imapSsl: {
			value: parseBooleanField(raw.imapSsl),
			disabled: false,
			isValid: false,
		},
		isRowValid: true,
	};
}

const CSVImportFileDialog: React.FC<CSVImportFileDialogProps> = ({
	open,
	onClose,
	onImport,
}) => {
	return (
		<ImportFileDialog<RowData>
			createEmptyRow={createEmptyRow}
			open={open}
			onClose={onClose}
			requiredColumns={columnsKey}
			parseRow={parseSenderRow}
			onImport={onImport}
		/>
	);
};

export default CSVImportFileDialog;
